export const constants = {
  routes: {
    main: '/',
    pokemon: '/pokemon',
    login: '/login',
    register: '/registrar',
    all: '*'
  },
  localStorageKey: 'user',
  page: {
    size: 20,
    name: 'page'
  },
  endpoints: {
    pokeapi: 'https://pokeapi.co/api/v2/'
  }
}
